export type PageStatusBannerProps = {
  type: 'loading' | 'error' | 'empty';
  message: string;
};

export const PageStatusBanner = ({ type, message }: PageStatusBannerProps) => {
  if (type === 'loading') {
    return (
      <div className="rounded-md bg-blue-50 p-4 text-blue-700">
        <div className="flex items-center gap-2">
          <span className="inline-block h-4 w-4 animate-spin rounded-full border-2 border-blue-700 border-t-transparent" />
          <span className="leading-none font-medium">{message}</span>
        </div>
      </div>
    );
  }

  if (type === 'error') {
    return (
      <div className="rounded-md bg-red-50 p-4 text-red-700">
        <div className="flex items-center gap-2">
          <i className="pi pi-times-circle text-base leading-none" />
          <span className="leading-none font-medium">{message}</span>
        </div>
      </div>
    );
  }

  return (
    <div className="rounded-md bg-gray-50 p-8 text-center">
      <i className="pi pi-info-circle mb-2 text-4xl text-gray-400" />
      <p className="text-gray-600">{message}</p>
    </div>
  );
};
